import React, { useState, useEffect } from "react"

import { useStaticQuery, graphql } from "gatsby"

import Title from "./Title"
import Project from "./Project"
import { Link } from "gatsby"

const Projects = ({ projects, title, showLink }) => {
  return (
    <section className="section projects">
      <Title title={title} />

      <div className="section-center project-wrapper">
        {projects.map(project => {
          return <Project key={project.id} {...project} />
        })}
      </div>

      {showLink && (
        <Link to="/project" className="btn center-btn">
          all projects
        </Link>
      )}
      
    </section>
  )
}

export default Projects

const LoadMore = () => {
const data = useStaticQuery(graphql`
    {
      allStrapiProjects {
        nodes {
          id
          slug
          title
        }
      }
    }
  `)
  // Array of all projects
  const allProjects = data.allStrapiProjects.nodes

  // State for the list
  const [projects, setList] = useState([...allProjects.slice(0, 10)])

  // State to trigger oad more
  const [loadMore, setLoadMore] = useState(false)

  // State of whether there is more to load
  const [hasMore, setHasMore] = useState(allProjects.length > 10)

  // Load more button click
  const handleLoadMore = () => {
    setLoadMore(true)
  }

  // Handle loading more projects
  useEffect(() => {
    if (loadMore && hasMore) {
      const currentLength = projects.length
      const isMore = currentLength < allProjects.length
      const nextResults = isMore
        ? allProjects.slice(currentLength, currentLength + 10)
        : []
      setList([...projects, ...nextResults])
      setLoadMore(false)
    }
  }, [loadMore, hasMore]) //eslint-disable-line

  //Check if there is more
  useEffect(() => {
    const isMore = projects.length < allProjects.length
    setHasMore(isMore)
  }, [projects]) //eslint-disable-line

  return (
    <section className="section projects">
      
      <div className="section-center project-wrapper">
        {projects.map(project => {
          return <Project key={project.id} {...project} />
        })}
      </div>
      {hasMore ? (
        <button onClick={handleLoadMore}>Load More</button>
      ) : (
        <p>No More Projects</p>
      )}      
    </section>
  )
}

